const AUTO_SAVE_ENABLED_STORAGE_KEY = "netpad:autoSaveEnabled";
const ENABLED_STORAGE_VALUE = "true";

/**
 * @returns {boolean}
 */
export const readAutoSavePreference = () =>
  localStorage.getItem(AUTO_SAVE_ENABLED_STORAGE_KEY) === ENABLED_STORAGE_VALUE;

/**
 * @param {boolean} isEnabled
 * @returns {void}
 */
export const storeAutoSavePreference = (isEnabled) => {
  localStorage.setItem(AUTO_SAVE_ENABLED_STORAGE_KEY, String(isEnabled));
};
